export const objectKeys = <T extends Record<string, unknown>>(
  input: T,
): Array<keyof T> => Object.keys(input);
